import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import {
  CheckDuplicateSectionCodeQuery,
  GenerateSectionCodeQuery,
  SectionApi,
} from 'api';

import { findDiaryListFromEntitySection } from './entitySectionSlice';

export const checkDuplicateSectionCode = createAsyncThunk(
  'section/checkDuplicateSectionCode',
  async (query: CheckDuplicateSectionCodeQuery, { rejectWithValue }) => {
    try {
      const response = await SectionApi.checkDuplicate(query);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const generateSectionCode = createAsyncThunk(
  'section/generateSectionCode',
  async (query: GenerateSectionCodeQuery, { rejectWithValue }) => {
    try {
      const response = await SectionApi.generateCode(query);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

interface IState {
  tableList: any[];
  list: any[];
  diaryList: any[];
  savedList: any[];
  savedPagination: any;
}

const initState: IState = {
  tableList: [],
  list: [],
  diaryList: [],
  savedList: [],
  savedPagination: { current: 1, next: 2, prev: 0, take: 10, total: 0 },
};

const sectionSlice = createSlice({
  name: 'section',
  initialState: initState,
  reducers: {
    updateSavedPaginationSection(state, action) {
      state.savedPagination = action.payload;
    },
    updateSavedListSection(state, action) {
      state.savedList = action.payload;
    },
  },
  extraReducers: builder => {
    builder.addCase(
      findDiaryListFromEntitySection.fulfilled,
      (state, action) => {
        const { data } = action.payload;
        const { steps } = data;

        state.diaryList = steps;
      }
    );
  },
});

const { actions, reducer: sectionReducer } = sectionSlice;

export const { updateSavedListSection, updateSavedPaginationSection } = actions;

export default sectionReducer;
